<template>
  <div>
    <div class="marTML pf23-subTit">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">참가 약관 동의</div>
    </div>
    <div class="widM marTML">
      <template v-if="requiredConsents.length > 0">
        <div class="fntH6 fntL bold marBSM" style="color:#2c2c2c;">필수항목 동의<span class="ico-must-astar"></span></div>

        <div
          v-for="(attendant, idx) in attendingList"
          :key="`required${idx}`"
          :class="{ padTM: idx > 0 }"
          class="pf23-itemAgree padBM" 
          style="border-bottom:1px solid #e3e3e3;"
        >
          <div class="floL fntP">{{ getAttendantName(attendant) }} (필수)</div>
          <div class="floR">
            <div class="amway-theme txtR">
              <div class="action pf23-radioBtn radio-wrapper pf23-itemAgree-radio" id="consent-require">
                <label class="amw-radio-wrap radio-label focus">
                  <input
                    type="radio"
                    :name="`required-consent${idx}`"
                    class="amw-global-radio"
                    value="Y"
                    @change="selectConsentYn(attendant, 'required', $event.target.value)"
                    :checked="attendant.consents.required === 'Y'"
                    :disabled="!infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">동의</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input
                    type="radio"
                    :name="`required-consent${idx}`"
                    class="amw-global-radio"
                    value="N"
                    @change="selectConsentYn(attendant, 'required', $event.target.value)"
                    :checked="attendant.consents.required === 'N'"
                    :disabled="!infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">동의 안함</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <p class="fntE padTS" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">*각 동의 항목에는 참여하는 참가자들이 모두 읽고 동의 여부를 직접 선택 해주시기 바랍니다.</p>

        <!-- S: 필수 약관 목록 -->
        <div
          v-for="(consent, idx) in requiredConsents"
          :key="consent.c_code"
          :class="{ marTML: idx === 0 }"
          style="background:#f3f3f3; border-top:1px solid #e3e3e3;"
        >
          <div class="widM">
            <div class="padTM padBM">
              <p class="fntP">[필수] {{ consent.title }}</p>
              <p class="txtR fntE padTS" style="color:#00305e;"><a @click="openConsentPopup(consent)">자세히 보기 &gt;</a></p>
            </div>
          </div>
        </div>
        <!-- E: 필수 약관 목록 -->
      </template>

      <template v-if="optionalConsents.length > 0">
        <div class="fntH6 fntL bold marTML marBM" style="color:#2c2c2c;">선택항목 동의</div>
        
        <div
          v-for="(attendant, idx) in attendingList"
          :key="`optional${idx}`"
          :class="{ padTM: idx > 0 }"
          class="pf23-itemAgree padBM"
          style="border-bottom:1px solid #e3e3e3;"
          
        >
          <div class="floL fntP">{{ getAttendantName(attendant) }}</div>
          <div class="floR">
            <div class="amway-theme txtR">
              <div class="action pf23-radioBtn radio-wrapper pf23-itemAgree-radio">
                <label class="amw-radio-wrap radio-label focus" id="consent-option">
                  <input
                    type="radio"
                    :name="`optional-consent${idx}`"
                    class="amw-global-radio"
                    value="Y"
                    @change="selectConsentYn(attendant, 'optional', $event.target.value)"
                    :checked="attendant.consents.optional === 'Y'"
                    :disabled="!infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">동의</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input
                    type="radio"
                    :name="`optional-consent${idx}`"
                    class="amw-global-radio"
                    value="N"
                    @change="selectConsentYn(attendant, 'optional', $event.target.value)"
                    :checked="attendant.consents.optional === 'N'"
                    :disabled="!infoAvailable"
                  />
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">동의 안함</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- S: 선택 약관 목록 -->
        <div
          v-for="consent in optionalConsents"
          :key="consent.c_code"
          class="marTML"
          style="background:#f3f3f3; border-top:1px solid #e3e3e3; border-bottom:1px solid #e3e3e3;"
        >
          <div class="widM">
            <div class="padTM padBM">
              <p class="fntP">[선택] {{ consent.title }}</p>
              <p class="txtR fntE padTS" style="color:#00305e;"><a @click="openConsentPopup(consent)">자세히 보기 ></a></p>
            </div>
          </div>
        </div>
        <!-- E: 선택 약관 목록 -->
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SYDNEY, ATTENDING_LIST, REQUIRED_CONSENTS, OPTIONAL_CONSENTS, SET_CONSENT_YN, GET_DATA_IDX_BY_TYPE, INFO_AVAILABLE } from '@/store/actions/survey'
import { CommonMethodMixin } from '../mixins'
import SurveyPopupConsent from './SurveyPopupConsent.vue'

export default {
  name: 'SurveyConsent',
  mixins: [CommonMethodMixin],
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      consents: state => state.consents || {}
    }),
    ...mapGetters(SURVEY_SYDNEY, {
      infoAvailable: INFO_AVAILABLE,
      attendingList: ATTENDING_LIST,
      requiredConsents: REQUIRED_CONSENTS,
      optionalConsents: OPTIONAL_CONSENTS,
      getDataIdx: GET_DATA_IDX_BY_TYPE,
    }),
  },
  methods: {
    openConsentPopup(consent) {
      this.openPopupLayer({
        headerText: '참가 약관 동의',
        component: SurveyPopupConsent,
        props: { content: consent.description },
        showHeader: true,
        showConfirmBtn: false
      });
    },
    /**
     * 필수, 선택 약관의 코드 리스트 리턴
     */
    getConsentsCodes(required) {
      return (required ? this.requiredConsents : this.optionalConsents).map(c => c.c_code);
    },
    /**
     * 약관 선택 시 응답 데이터 변경
     */
    selectConsentYn(attendant, key, yn) {
      const idx = this.getDataIdx(attendant.type, attendant.type_seq);
      this.$store.commit(`${SURVEY_SYDNEY}/${SET_CONSENT_YN}`, { idx, key, yn });
    },
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyConsent.vue